import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsOptionComponent } from "./ds-option/ds-option.component";
import { DsDropdownTriggerComponent } from "./ds-dropdown-trigger/ds-dropdown-trigger.component";
import { DsCheckboxModule } from "../ds-checkbox/ds-checkbox.module";
import { DsOptionGroupComponent } from "./ds-option-group/ds-option-group.component";

@NgModule({
  declarations: [DsOptionComponent, DsDropdownTriggerComponent, DsOptionGroupComponent],
  imports: [CommonModule, DsCheckboxModule],
  exports: [DsOptionComponent, DsDropdownTriggerComponent, DsOptionGroupComponent],
})
export class DsSelectorComponentsModule {}
